/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface User {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: string;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface AuthorizationType {
  /** 권한타입 객체 오브젝트 아이디 */
  _id: string;
  /**
   * 샘플 데이터 구분
   * @default false
   */
  isSample?: boolean;
  /** 권한타입이 속한 병원 아이디 */
  hospitalID: string;
  /** 권한타입의 이름. 마스터, 관리자, 일반 중 하나 */
  name?: string;
  /** 환자 채팅 관리 권한 */
  canControlPatientChatting?: boolean;
  /** 환자 서비스 차단 권한 */
  canBanPatientToService?: boolean;
  /** 자동화 설정 권한 */
  canUpsertAutomation?: boolean;
  /** 자동화 삭제 권한 */
  canDeleteAutomation?: boolean;
  /** 자동화 대시보드 조회 권한 */
  canReadAutomationDashboard?: boolean;
  /** 콘텐츠 수정 권한 */
  canUpsertContent?: boolean;
  /** 콘텐츠 삭제 권한 */
  canDeleteContent?: boolean;
  /** 메뉴얼 폴더 및 태그 설정 권한 */
  canControlManualFolderAndTagStatus?: boolean;
  /** 메뉴얼 생성 권한 */
  canCreateManual?: boolean;
  /** 병원 정보 조회 권한 */
  canAccessHospitalInformation?: boolean;
  /** 서비스 정보 조회 권한 */
  canAccessHospitalService?: boolean;
  /** 계정 정보 조회 권한 */
  canAccessHospitalAccount?: boolean;
  /** 결제 관리 접근 권한 */
  canAccessPaymentManagement?: boolean;
  /** 결제 권한 */
  canCreatePayment?: boolean;
  /** 서비스 정보 수정 권한 */
  canModifyService?: boolean;
  /** 서비스 종료 권한 */
  canSuspendService?: boolean;
  /** 예약설정 수정 권한 */
  canManageReservation?: boolean;
  /** 예약설정 스케줄 수정 권한 */
  canManageSchedule?: boolean;
  /** 병원정보 수정 권한 */
  canUpdateHospital?: boolean;
  /** 환자 정보 다운로드 권한 */
  canDownloadPatientData?: boolean;
  /** 재진 마케팅 등록/수정 */
  canUpsertMarketingAutomation?: boolean;
  /** 재진 마케팅 삭제 */
  canDeleteMarketingAutomation?: boolean;
  /** 대시보드 조회 여부 */
  canReadMarketingAutomationDashboard?: boolean;
  /** 결제 정보 조회 여부 */
  canReadPaymentRecords?: boolean;
  /** 재진마케팅 전송 기록 엑셀 다운로드 권한 */
  canDownloadMarketingHistory?: boolean;
  /** 상담자동화 발송 기록 엑셀 다운로드 권한 */
  canDownloadConsultationHistory?: boolean;
  /** 메디팔 AI 사용현황 조회 권한 */
  canReadMedipalAIUsage?: boolean;
  /** 메디팔 AI 업무 조정 권한 */
  canAdjustMedipalAITask?: boolean;
  /** 메디팔 AI 예약 조회 권한 */
  canReadMedipalAIReservation?: boolean;
  /** 메디팔 AI 콜 조회 권한 */
  canReadMedipalAICall?: boolean;
  /** 메디팔 AI 콜 최고 권한 */
  canControlMedipalAICall?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface UserHServicePhotoAuthorizationType {
  /** 사용자 아이디 - ObjectId */
  _id: string;
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: File;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: HServiceNurseDoctorHospitalChatroom[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
  /**
   * 기본 상담사 여부
   * @default false
   */
  isDefaultCounselor: boolean;
}

export interface File {
  /**
   * 파일 ID
   * @example "66aca461f8238a4fd30abe15"
   */
  _id: string;
  /** 파일의 소유자 ID */
  userID?: string;
  /**
   * 파일 타입
   * - 300: Image
   * - 400: Video
   * - 500: File
   */
  type: number;
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths: string[];
  /** 파일 별, S3 스토리지에 업로드 된 파일의 정보 객체 배열 */
  aws?: Record<string, any>[];
  /** 파일 만료일. 외부 연동 서비스일 경우에 존재 */
  expiredAt?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface HServiceNurseDoctorHospitalChatroom {
  /** 서비스 대상이 되는 유저 ID */
  userID?: string;
  /** 서비스 대상의 이름 */
  name?: string;
  /** 서비스 대상의 생년월일 */
  birth?: string;
  /** 서비스 대상의 전화번호 */
  phone?: string;
  /** 서비스 대상의 성별 */
  gender?: string;
  /** 서비스 대상의 차트번호 */
  chartNumber?: string;
  /** 서비스 진행 매니저의 ID */
  nurseID?: UserPhoto;
  /** 서비스 진행 매니저가 여럿인 경우의 매니저 ID 배열 */
  nurseIDs?: any[];
  /** 담당의 유저 ID */
  doctorID?: User;
  /** 서비스가 진행중인 병원의 ID */
  hospitalID?: HospitalRepresentImage;
  /** 서비스 내 포함된 채팅방 ID */
  chatRoomID?: ChatRoom;
  /** 전능 대표 연동 고객번호 (유일) */
  ALCustomerNumber?: string;
  /** 전능 연동 고객번호 리스트 */
  ALCustomerNumbers?: any[];
  /** 서비스 내 작성된 모든 메모의 ID 배열 */
  memos?: any[];
  /** 매니저만 작성/열람 가능한 메모 ID 배열 */
  managementDiaries?: any[];
  /** 고객 태그 ObjectID 배열 */
  userTagIDs?: any[];
  /** 환자 설정 완료 여부(설정/미설정 수 count용) */
  hasPatientSetting?: boolean;
  /** 초기 치료내역 문자열 배열 */
  initialTreatments?: any[];
  /** 초기 치료내역 중  기타를 선택하고 입력한 내역 */
  etcTreatments?: string;
  /** 읽지 않은 매니저 메모의 존재 여부 */
  hasUnreadNurseMemo?: boolean;
  /** 읽지않은 병원 메모 존재 유무 */
  hasUnreadDoctorMemo?: boolean;
  /** 문자유입 프로세스를 통해 서비스를 시작한 경우 유입 Link */
  shortLinkID?: string;
  /** 링크형태의 웹을 통해 진입한 유저의 경우 Type */
  linkType?: string;
  /** 서비스 환자에 대한 간단 설명 */
  description?: string;
  /** 병원 계정의 경우  new 뱃지 표기를 위한 플래그 */
  new?: boolean;
  /** 가입 상태에 대한 string 플래그 */
  status?: string;
  /** query를 위한 서비스 시작 여부 플래그 */
  isRun?: boolean;
  /** 서비스 종료 구분 플래그 */
  isClosed?: boolean;
  /** 서비스 종료시 사용자가 선택한 서비스 종료 이유. 혹은 병원에서 서비스를 종료한 후 사용자에게 보여주기 위한 문구. */
  closeReason?: any[];
  /** 서비스 약관 동의 일시 (HService 기준) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (HService 기준) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (HService 기준) */
  agree_sensitive?: string;
  /** 가입일시 */
  joinedAt?: string;
  /** 서비스 대상 유저의 마지막 로그인 일시 */
  lastLogin?: string;
  /** 마지막 유저의 채팅 모델 ID */
  lastUserChat?: string;
  /** 마지막 유저의 채팅 전송 일시 */
  lastUserChatDate?: string;
  /** 마지막 유저 채팅 존재 유무 */
  hasLastUserChat?: boolean;
  /** 마지막 매니저의 채팅 모델 ID */
  lastNurseChat?: string;
  /** 마지막 매니저의 채팅 전송 일시 */
  lastNurseChatDate?: string;
  /** 마지막 매니저 채팅 존재 유무 */
  hasLastNurseChat?: boolean;
  /** 채팅방에서 마지막으로 수신한 메세지 */
  lastMessage?: string;
  /** 마지막으로 수신된 메세지의 수신 일시 */
  lastMessageUpdatedAt?: string;
  /** 마지막 가입 문자 메시지 수신일자 */
  lastSMSDate?: string;
  /** 고객 유형(치료 유형) 카테고리 ID 목록 */
  treatmentCategories?: any[];
  /** 치료시작일 */
  treatmentStartDate?: string;
  /** 초진/재진 여부 */
  isFirstVisit?: boolean;
  /** 테스트 계정 여부. */
  isTest?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** // 미가입 - 발송 예정인 기본 운동콘텐츠 목록 */
  reservedVCHIDs?: any[];
  /** 전송된 운동콘텐츠의 중 카테고리 ObjectID 배열. 누적 */
  vccIDs?: any[];
  /** 가장 최근에 운동콘텐츠가 전송된 날짜 */
  lastVCUDate?: string;
  /** 모든 운동콘텐츠가 종료되는 날짜 */
  lastVCUEndDate?: string;
  /** 직접 전송한 운동콘텐츠 유무. */
  hasVCU?: boolean;
  /** 병원에서 설정한 평균 이행률 이상 달성했는지 여부 */
  isOverHCompletionRate?: boolean;
  /** 운동콘텐츠 진행중 여부. */
  isVCUOngoing?: boolean;
  /** 합산 공유횟수(현재 반올림 하여 정수로 표현중이나  변경될 수 있음.) */
  sumShareCount?: number;
  /** 평균 이행률(현재 반올림 하여 정수로 저장하나  double 로 변경될 수 있음) */
  avgCompletionRate?: number;
  /** 운동콘텐츠 전송 필요 종모양 알람 표시 여부 */
  needVCU?: boolean;
  /** 운동콘텐츠 발송화면(Electron) 에서의 정렬을 위한 코드 */
  sortDigitVC?: string;
  /** 구분정보1 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote1?: string;
  /** 구분정보2 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote2?: string;
  /** 서비스 시작을 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 서비스 시작일 */
  startedAt?: string;
}

export interface UserPhoto {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: File;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface HospitalRepresentImage {
  /** 병원의 정식 명칭 */
  name?: string;
  /** 사용자에게 보여질 병원명 */
  shortName?: string;
  /** 병원 주소 */
  address?: string;
  /** 병원 주소체계 검색 및 지도용 주소 정보 */
  addressInfo?: Record<string, any>;
  /** 네이버 지도 API 사용을 위한 주소 정보 */
  addressInfoNaver?: Record<string, any>;
  /** 병원의 과 ID */
  department?: any[];
  /** 병원 소개 글 */
  introduction?: string;
  /** 병원 정보페이지에 노출 될 이미지 파일 ID */
  representImage?: File;
  /** 대표 원장님 */
  representUser?: string;
  /** 병원의 홈페이지 URL */
  homepageURL?: string;
  /** 병원 전화번호 */
  phone?: string;
  /** 병원 전화번호 숨김 여부 */
  isHiddenPhoneNumber?: boolean;
  /** 병원 홈페이지 / 전화번호 사용여부 */
  usingHomepage?: boolean;
  /** 초기 채팅 발송 문구 */
  initialChat?: any[];
  /** 초기 채팅 발송 문구 (텍스트 및 이미지) */
  initialChats?: any[];
  /** 환자 관리를 위해서 매니저가 사용할 ServiceFlagCategory의 디폴트 값 아이디 */
  defaultFlag?: string;
  /** 1차 프로덕트에서 사용된 치료 목록 */
  therapyList?: any[];
  /** 서비스 매니저측에서 병원에 대한 특이사항을 기록하기 위한 JSON Object. */
  additionalInfo?: Record<string, any>;
  /** 문자유입 프로세스 내에서 기본 메세지 발송 여부 플래그 */
  isBasicMessage?: boolean;
  /** 문자유입 시 발송될 기본 문구 */
  smsMessage?: string;
  /** AB 테스트를 위한 메세지 문구 A */
  smsMessageA?: string;
  /** AB 테스트를 위한 메세지 문구 B */
  smsMessageB?: string;
  /** 자동 발송될 기본 채팅 메세지 */
  smsChatMessage?: string;
  /** AB 테스트를 위한 초기 채팅 메세지 A */
  smsChatMessageA?: string;
  /** AB 테스트를 위한 초기 채팅 메세지 B */
  smsChatMessageB?: string;
  /** 고객등록시 가입 문자 직접입력 설정 여부 */
  usingBasicMessage?: boolean;
  /** 고객등록시 가입 문자 기본 문구 */
  smsBasicMessage?: string;
  /** 고객등록시 가입 문자 직접 입력 문구 */
  smsBasicMessageEdit?: string;
  /** 예약등록시 가입 문자 직접입력 설정 여부 */
  usingReservationMessage?: boolean;
  /** 예약등록시 가입 문자 기본 문구 */
  smsReservation?: string;
  /** 예약등록시 가입 문자 직접 입력 문구 */
  smsReservationEdit?: string;
  /** 기존 고객 가입 문자 재발송 직접입력 설정 여부 */
  usingResendMessage?: boolean;
  /** 기존 고객 가입 문자 재발송 기본 문구 */
  smsResendMessage?: string;
  /** 기존 고객 가입 문자 재발송 직접 입력 문구 */
  smsResendMessageEdit?: string;
  /** 채팅 예약 발송 시 커스텀 메시지 */
  chatReservationGuide?: string;
  /** 진료 시간 */
  careSchedule?: any[];
  /** 진료 시간 설명 */
  careScheduleDescription?: string;
  /** 문자 유입내 사용할 이미지 파일 ID */
  smsLogoImage?: string;
  /** 문자유입간 이미지의 사용 여부 */
  isUsingLogo?: boolean;
  /** 담당 서비스매니저의 UserID */
  nurseID?: string;
  /** 병원별 여러명의 서비스 매니저를 담기 위한 서비스매니저의 User ID 배열 */
  nurseIDs?: any[];
  /** 담당 서비스 매니저가 여럿인지, 단일이지 구분짓기 위한 플래그 */
  hospitalType?: string;
  /** 문자 유입 사용여부 플래그 */
  usingRegistUser?: boolean;
  /** 서비스 진행 여부 플래그 */
  isClosed?: boolean;
  /** 서비스 설정 모델 ObjectId */
  serviceSetting?: string;
  /** 현재 모바일에서 예약가능한 시트가 존재하는지 확인하기 위한 플래그 */
  hasActiveSheet?: boolean;
  /** 2차 프로덕트 사용여부. */
  isSecondEdition?: boolean;
  /** 홈케어 콘텐츠 모듈 사용 여부 */
  usingVideoContent?: boolean;
  /** 병원 이벤트 모듈 사용여부 */
  usingHospitalEvent?: boolean;
  /** 모바일 홈화면에 표시될 건강 관리 뉴스 카테고리. */
  healthContentCategory?: any[];
  /** 건강콘텐츠 사용 여부 */
  usingHealthContent?: boolean;
  /** 병원 소식 사용 여부 */
  usingHospitalContent?: boolean;
  /** 연동 설정 모델 ObjectId */
  integrationSetting?: string;
  /** 애프터닥 운영시간 종료 후 환자 채팅 시, 팝업 표시 여부 */
  usingAfterhoursPopup?: boolean;
  /** 애프터닥 운영시간 종료 후 환자 채팅 시, 표시할 팝업 내용 */
  afterhoursPopupContent?: string;
  /** 자동 가입문자 재발송 사용 여부 */
  usingAutoReservedSMS?: boolean;
  /** 자동 재가입 문자 발송에 사용될 콘텐츠 */
  autoReservedSMSMessage?: string;
  /** 자동 재가입 문자 발송까지 대기할 날 */
  autoReservedSMSDelayDay?: number;
  /** 자동 재가입 문자가 발송될 시간 */
  autoReservedSMSHour?: number;
  /** 예약 시트 2차 버전 사용 여부 */
  usingV2ReservationSheet?: boolean;
  /** SaaS 예약시트 사용 여부 */
  usingSaaSReservation?: boolean;
  /** SaaS 프로덕트 사용 여부 */
  isEnabledSaaS?: boolean;
  /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
  locale?: string;
  /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
  timezone?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface ChatRoom {
  /** 채팅방에 참여중인 서비스 ID */
  hserviceID?: string;
  /** 채팅방에 참여중인(Push notification을 받아야 하는.) 유저의 ID 배열 */
  users?: any[];
  /** 채팅의 주 대상이 되는(환자 or 의사) 유저의 ID */
  userID?: string;
  /** 채팅방 ID(_ID와 동일하고 _ID 사용 권장) */
  id?: string;
  /** 채팅방 _ID */
  _id: string;
  /** 채팅방 제목 */
  title?: string;
  /** 서비스매니저가 읽지 않은 채팅의 수 */
  n_UnreadCount?: number;
  /** 대상 유저가 읽지 않은 채팅의 수 */
  c_UnreadCount?: number;
  /** 채팅의 대상이 되는 유저가 처음 진입했는가에 대한 질의를 위한 플래그 */
  c_isFirstEnter?: boolean;
  /** 서비스 매니저의 첫 메세지 전송 여부 플래그 */
  c_isFirstNurseChat?: boolean;
  /** 대상 유저의 첫 메세지 구분 플래그 */
  c_isFirstUserChat?: boolean;
  /** 매니저의 첫 메세지 전송 이후를 확인하기 위한 플래그 */
  c_isSendedFirstNurseChat?: boolean;
  /** 해당 채팅방의 귀속 병원 ID */
  hospitalID?: string;
  /** 병원 계정과의 채팅방임을 구분짓는 플래그 */
  isDoctor?: boolean;
  /** 첫 메세지 전송을 통한 SMS 전송 여부 구분 플래그 */
  hasFirstSMS?: boolean;
  /** 마지막으로 전달된 메세지 모델 ID */
  lastMessage?: string;
  /** 마지막 메세지 전달 일시 */
  lastMessageUpdatedAt?: string;
  /** 채팅방 내에서의 총 메세지 수 */
  totalChatCount?: number;
  /** 마지막으로 환자가 전달한 채팅의 ObjectId */
  lastUserChat?: string;
  /** 마지막으로 환자가 전달한 채팅의 일시 */
  lastUserChatDate?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 ObjectId */
  lastNurseChat?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 일시 */
  lastNurseChatDate?: string;
  /** 참여 유저별 뱃지 카운트 정보 */
  badgeCountInfo?: Record<string, any>;
  /** 사용자 ID 별 필요한 정보의 집합 */
  info: {
    /**
     * 사용자 ID
     * @example "60b12345b1234c56789abcd1"
     */
    userID: string;
    /**
     * 채팅을 읽지 않은 갯수
     * @example 0
     */
    count: number;
    /**
     * 개인별 출력되는 채팅방 제목
     * @example "단체방"
     */
    title: string;
  }[];
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 채팅방의 병원 응대 필요 (상담 요청) 여부 */
  isChatResponseRequired?: boolean;
  /** 병원 응대 필요 채팅 (상담 요청) 존재 여부 */
  hasUnreadChatResponseRequired?: boolean;
  /** 채팅방 삭제 여부 */
  isRemoved?: boolean;
  /** 채팅방 타입 정의 */
  roomType?: string;
  /** 카카오 상담톡을 위한 추가 정보 */
  ikakaoInfo?: Record<string, any>;
  /** 채팅방의 담당자 ID 배열 */
  counselors?: any[];
  /**
   * 상담 진행중 여부
   * @default false
   */
  isCounselInProgress?: boolean;
  /**
   * 번역 사용 여부
   * @default false
   */
  usingTranslation?: boolean;
  /** 언어 ObjectId */
  languageID?: string;
  /** 활성화 여부 */
  isActive?: boolean;
  /** 채팅방에 연결된 부모 서비스 ID. 연동된 내용이 없으면 hserviceID와 동일 */
  parentHServiceID: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface UserAuthorizationType {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: string;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface ApiHworkersElFindParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiHworkersElFindData = ApiResponse & {
  data: User[];
};

export interface ApiHworkersElFindOneParams {
  /** (required) 병원ID */
  userID?: string;
}

export type ApiHworkersElFindOneData = ApiResponse & {
  data: UserHServicePhotoAuthorizationType;
};

export interface ApiHworkersElFindCounselorParams {
  /** (required) 병원ID */
  hospitalID?: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: number;
}

export type ApiHworkersElFindCounselorData = ApiResponse & {
  data: UserAuthorizationType[];
};

export type ApiHworkersElUpdateData = ApiResponse & {
  data: User;
};

export type ApiHworkersElUpdateDashboardData = ApiResponse & {
  data: User;
};

export type ApiHworkersElAuthorizationData = ApiResponse & {
  data: {
    /** 유저 역할 */
    role: "MASTER" | "ADMIN" | "STAFF";
    permissions?: {
      /** 전체 담당자 채팅 조회 가능 여부 */
      canControlPatientChatting: boolean;
      /** 고객 정보 등록/변경 가능 여부 */
      canUpsertPatientInformation: boolean;
      /** 고객 이용 제외 상태로 제어 가능 */
      canBanPatientToService: boolean;
      /** 예약, 근무일정 설정 제어 가능 여부 */
      canControlReservationAndWorkingScheduleSetting: boolean;
      /** 근무 일정 등록/변경 가능 여부 */
      canUpsertWorkingSchedule: boolean;
      /** 예약 현황 조회 가능 여부 */
      canReadReservationHistory: boolean;
      /** 예약관리화면 내에서 고객(환자) 정보 변경 가능 여부 */
      canUpdatePatientInformationWithinReservation: boolean;
      /** 자동화 세트 등록 / 변경 가능 여부 */
      canUpsertAutomation: boolean;
      /** 자동화 삭제 가능 여부 */
      canDeleteAutomation: boolean;
      /** 자동화 대시보드 조회 가능 여부 */
      canReadAutomationDashboard: boolean;
      /** 콘텐츠 등록 / 변경 가능 여부 */
      canUpsertContent: boolean;
      /** 콘텐츠 삭제 가능 여부 */
      canDeleteContent: boolean;
      /** 매뉴얼 폴더 및 태그 사용 여부 설정 가능에 대한 여부 */
      canControlManualFolderAndTagStatus: boolean;
      /** 매뉴얼 작성 가능 여부 */
      canCreateManual: boolean;
      /** 매뉴얼 삭제 가능 여부 */
      canDeleteManual: boolean;
      /** 병원 정보 접근 가능 여부 */
      canAccessHospitalInformation: boolean;
      /** 병원 서비스 접근 가능 여부 */
      canAccessHospitalService: boolean;
      /** 병원 계정 접근 가능 여부 */
      canAccessHospitalAccount: boolean;
    };
  };
};

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * No description
     *
     * @tags V3-HWorker
     * @name ApiHworkersElFind
     * @summary 병원 유저 정보 조회
     * @request GET:/v3/api/hworkers/el/find
     * @secure
     * @response `200` `ApiHworkersElFindData` \[\{User\}\] User 객체 배열 조회
     */
    apiHworkersElFind: (query: ApiHworkersElFindParams, params: RequestParams = {}) =>
      this.request<ApiHworkersElFindData, any>({
        path: `/v3/api/hworkers/el/find`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HWorker
     * @name ApiHworkersElFindOne
     * @summary 병원 유저 정보 조회
     * @request GET:/v3/api/hworkers/el/find/one
     * @secure
     * @response `200` `ApiHworkersElFindOneData` \{User\} 객체 조회
     */
    apiHworkersElFindOne: (query: ApiHworkersElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiHworkersElFindOneData, any>({
        path: `/v3/api/hworkers/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HWorker
     * @name ApiHworkersElFindCounselor
     * @summary 담당자로 설정 가능한 병원 직원 정보 조회
     * @request GET:/v3/api/hworkers/el/find/counselor
     * @secure
     * @response `200` `ApiHworkersElFindCounselorData` \[\{User\}\] 담당자로 설정 가능한 User 객체 배열 조회
     */
    apiHworkersElFindCounselor: (query: ApiHworkersElFindCounselorParams, params: RequestParams = {}) =>
      this.request<ApiHworkersElFindCounselorData, any>({
        path: `/v3/api/hworkers/el/find/counselor`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HWorker
     * @name ApiHworkersElUpdate
     * @summary 병원 유저 정보 수정
     * @request POST:/v3/api/hworkers/el/update
     * @secure
     * @response `200` `ApiHworkersElUpdateData` \{User\} 업데이트된 User 모델 객체
     */
    apiHworkersElUpdate: (
      data: {
        /** 수정하고자 하는 유저의 오브젝트 아이디 */
        userID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHworkersElUpdateData, any>({
        path: `/v3/api/hworkers/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-HWorker
     * @name ApiHworkersElUpdateDashboard
     * @summary 유저 대시보드 접근권한 수정
     * @request POST:/v3/api/hworkers/el/update/dashboard
     * @secure
     * @response `200` `ApiHworkersElUpdateDashboardData` \{User\} 모델 객체
     */
    apiHworkersElUpdateDashboard: (
      data: {
        /** 수정하고자 하는 유저의 오브젝트 아이디 */
        userID?: string;
        /** 대시보드 접근 여부 */
        canReadDashboard?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiHworkersElUpdateDashboardData, any>({
        path: `/v3/api/hworkers/el/update/dashboard`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 현재 로그인한 일렉트론 유저의 권한 정보를 조회합니다.
     *
     * @tags V3-HWorker
     * @name ApiHworkersElAuthorization
     * @summary 일렉트론 유저 권한 조회
     * @request GET:/v3/api/hworkers/el/authorization
     * @secure
     * @response `200` `ApiHworkersElAuthorizationData` 권한 조회 성공
     */
    apiHworkersElAuthorization: (params: RequestParams = {}) =>
      this.request<ApiHworkersElAuthorizationData, any>({
        path: `/v3/api/hworkers/el/authorization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
